// Browser hand-off to IBM Cloud for watsonx single sign-on.
//
// The api returns either { mode: 'post', acsUrl, SAMLResponse, RelayState } (a
// signed SAML assertion that must reach IBM as an HTML form POST - the SAML
// HTTP-POST binding) or { mode: 'redirect', url }.

export const PENDING_SSO_KEY = 'heidi_watsonx_pending_sso';

// Every hand-off to IBM Cloud opens in this one named tab, so going back and
// forth between Heidi and IBM is switching between two tabs, not a growing pile.
export const WATSONX_TAB = 'heidi-watsonx';

// IBM-initiated sign-in lands on /watsonx/sso/<request>. When the user is not
// signed in to Heidi yet, the router bounces to /login and drops the path, so
// remember the request here - this module loads with the toolbar, before any
// route renders - and let the toolbar resume it after login.
if (typeof window !== 'undefined') {
	const match = window.location.pathname.match(/^\/watsonx\/sso\/([A-Za-z0-9]{16,128})\/?$/);
	if (match) {
		try {
			sessionStorage.setItem(PENDING_SSO_KEY, match[1]);
		} catch (e) {
			// storage disabled: the page itself still completes when already signed in
		}
	}
}

export function takePendingSsoRequest() {
	try {
		const key = sessionStorage.getItem(PENDING_SSO_KEY);
		if (key) sessionStorage.removeItem(PENDING_SSO_KEY);
		return key;
	} catch (e) {
		return null;
	}
}

/**
 * Send `win` (a window we control) to IBM with the api's hand-off.
 */
export function submitHandoff(win, handoff) {
	if (!handoff) throw new Error('No hand-off from the server');
	if (handoff.mode === 'redirect') {
		win.location.href = handoff.url;
		return;
	}
	const doc = win.document;
	const form = doc.createElement('form');
	form.method = 'POST';
	form.action = handoff.acsUrl;
	const fields = { SAMLResponse: handoff.SAMLResponse, RelayState: handoff.RelayState || '' };
	Object.keys(fields).forEach((name) => {
		if (name === 'RelayState' && !fields[name]) return;
		const input = doc.createElement('input');
		input.type = 'hidden';
		input.name = name;
		input.value = fields[name];
		form.appendChild(input);
	});
	doc.body.appendChild(form);
	form.submit();
}

/**
 * The api's error body and status. Heidi's axios interceptor (jwtService) rejects
 * with the RESPONSE itself, so the body is at err.data; a network error or an
 * interceptor-free call still carries it at err.response.data.
 */
export function apiError(err) {
	const data = (err && (err.data || (err.response && err.response.data))) || {};
	const status = (err && (err.status || (err.response && err.response.status))) || null;
	const message = typeof data === 'string'
		? data
		: (data.message || (data.errors && data.errors[0] && data.errors[0].msg) || null);
	return { status, message };
}
